import React from 'react'
import { useTranslation } from 'react-i18next' // @ts-nocheck

import {
  SimpleResourceTypeEntity,
  useResourceTypeAdminFindMany,
  useResourceTypeFindMany,
} from '@/api'
import { KBSelect, KBSelectProps } from '@/components/atoms'
import { ALL_OPTIONS } from '@/components/utils'
import { isUserClient } from '@/utils/userEnvironment'
import { MAX_PAGINATION_LIMIT } from '@/utils/constants'

interface Option {
  value: number
  label: string
  model?: SimpleResourceTypeEntity | undefined
}

interface KBResourceTypeSelectProps extends KBSelectProps {
  /**
   * If true, the component will show an "All" option
   */
  includeAllOption?: boolean
}

export const KBResourceTypeSelect: React.FC<KBResourceTypeSelectProps> = (
  props
) => {
  const { t } = useTranslation()
  const { includeAllOption, ...restProps } = props
  const [options, setOptions] = useState<Option[]>([])

  const { data, isPending } = isUserClient()
    ? useResourceTypeFindMany({ is_enabled: true, limit: MAX_PAGINATION_LIMIT })
    : useResourceTypeAdminFindMany({
        is_enabled: true,
        limit: MAX_PAGINATION_LIMIT,
      })

  useEffect(() => {
    const _options: Option[] = (data?.result || [])?.map(
      (resourceType: SimpleResourceTypeEntity) => ({
        value: resourceType.id!,
        label: resourceType.name!,
        model: resourceType,
      })
    )
    if (includeAllOption) {
      _options.unshift({
        value: ALL_OPTIONS,
        label: t('all.resourceTypes'),
        model: undefined,
      })
    }
    setOptions(_options)
  }, [data, includeAllOption])

  return (
    <KBSelect
      style={{ width: 200 }}
      {...restProps}
      loading={isPending}
      options={options}
      onChange={(value, option) => {
        if (!value || value === ALL_OPTIONS) {
          props.onChange?.(undefined, option)
          return
        }
        const resourceTypeId = parseInt(value)
        props.onChange?.(resourceTypeId, option)
      }}
    />
  )
}

export default KBResourceTypeSelect
